'use strict'
import request from '@/utils/request'
import qs from 'qs'
export {
  addComment,
  userLogin, // 匿名登录
  freeUse, // 免费试用
  getFormControl, // 获取表单控件
  getCode, // 发送验证码
  getHomeNewsList,//新闻列表
  getHomeHotsList,//公司热点
}
const addComment = (data, systemId, appId, formId) =>
  request({
    url: `webform/v1/system/${systemId}/app/${appId}/form/${formId}/add`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
const userLogin = (data) =>
  request({
    url: 'user/oauth/token',
    method: 'post',
    data: qs.stringify(data),
    auth: {
      username: 'yunsa',
      password: 'yunsa',
    },
  })
const freeUse = (data) =>
  request({
    url: '',
    method: 'post',
    data,
  })
const getFormControl = (data) =>
  request({
    url: `webform/v1/system/${data.systemId}/app/${data.appId}/form/${data.formId}/control?flow=true`,
  })
const getCode = (data) =>
  request({
    url: 'user/v1/user/getPhoneCode',
    method: 'post',
    data: qs.stringify(data),
  })
const getHomeNewsList = (data) =>
  request({
    url: `webform/v1/system/91F0FD9EBBB84E82AE0223C35B7ADF0B/app/C9176FF08DB443AF8C7E3A53E62CBC90/form/C3F6301C870842329FECAF3940C3CD27/find`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })
const getHomeHotsList = (data) =>
  request({
    url: `webform/v1/system/91F0FD9EBBB84E82AE0223C35B7ADF0B/app/C9176FF08DB443AF8C7E3A53E62CBC90/form/4a42d09c36244f5794eda1b2e212048e/find`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  })